module.exports = __webpack_public_path__ + "img/file-earmark-ruled-fill.917a6224.svg";